<template>
  <div>
    <VCard
      class="mb-4"
      outlined
    >
      <v-tabs
        v-model="activeTab"
        grow
      >
        <v-tab
          v-for="(tab, index) in tabs"
          :key="index"
          :to="tab.route"
        >
          {{ tab.name }}
        </v-tab>
      </v-tabs>
      <NuxtPage />
    </VCard>
  </div>
</template>

<script setup lang="ts">
import { useConfigStore } from '@/stores/config'
import { computed, onMounted, ref } from 'vue'

const configStore = useConfigStore()

// Generate tabs dynamically from config store
const tabs = computed(() =>
  configStore.environments.map((env: any) => ({
    name: env.aliasName,
    route: `/master-data/used-tags/${env.name}`,
  })),
)

const activeTab = ref(0) // Tracks the active tab index

onMounted(async () => {
  // Ensure environments are loaded
  if (configStore.environments.length === 0) {
    await configStore.fetchDataEnvironment()
  }

  // Handle redirect to first environment if we're on the index page
  const route = useRoute()
  if (route.path === '/master-data/used-tags' && configStore.environments.length > 0) {
    await navigateTo(`/master-data/used-tags/${configStore.environments[0].name}`)
  }
})
</script>
